var map = {
	"./AC.svg": "22ba",
	"./AD.svg": "ba28",
	"./AE.svg": "e34f",
	"./AF.svg": "4bc1",
	"./AG.svg": "2e13",
	"./AI.svg": "9d4e",
	"./AL.svg": "9e86c",
	"./AM.svg": "6ecf",
	"./AO.svg": "2754",
	"./AQ.svg": "2919",
	"./AR.svg": "91c0",
	"./AS.svg": "489f",
	"./AT.svg": "c24c",
	"./AU.svg": "f990",
	"./AW.svg": "df5a",
	"./AX.svg": "dc99",
	"./AZ.svg": "0ee3",
	"./BA.svg": "b91f",
	"./BB.svg": "dfc1",
	"./BD.svg": "9725",
	"./BE.svg": "ef86",
	"./BF.svg": "71b0",
	"./BG.svg": "3f1b",
	"./BH.svg": "f6fe",
	"./BI.svg": "97b8",
	"./BJ.svg": "56ff",
	"./BL.svg": "5ceb",
	"./BM.svg": "ea6c",
	"./BN.svg": "0428",
	"./BO.svg": "618d",
	"./BQ.svg": "2fd4",
	"./BR.svg": "5499",
	"./BS.svg": "6a10",
	"./BT.svg": "42bc",
	"./BV.svg": "3773",
	"./BW.svg": "b5a9",
	"./BY.svg": "d8a6",
	"./BZ.svg": "468c",
	"./CA.svg": "fdb8",
	"./CC.svg": "cae8",
	"./CD.svg": "71e9",
	"./CF.svg": "d367",
	"./CG.svg": "c17f",
	"./CH.svg": "bed3",
	"./CI.svg": "05e9",
	"./CK.svg": "ca5d",
	"./CL.svg": "b083",
	"./CM.svg": "c738",
	"./CN.svg": "99a4",
	"./CO.svg": "92da",
	"./CR.svg": "8a83",
	"./CU.svg": "7e2f",
	"./CV.svg": "daee",
	"./CW.svg": "18d4",
	"./CX.svg": "ec1a",
	"./CY.svg": "d966",
	"./CZ.svg": "f8fb",
	"./DE.svg": "e82d",
	"./DJ.svg": "7110",
	"./DK.svg": "9572",
	"./DM.svg": "d240",
	"./DO.svg": "5d9c",
	"./DZ.svg": "ffa8",
	"./EC.svg": "d5ae",
	"./EE.svg": "8341",
	"./EG.svg": "e3e6",
	"./EH.svg": "b983",
	"./ER.svg": "46fe",
	"./ES.svg": "0a5e",
	"./ET.svg": "2738",
	"./EU.svg": "0d03",
	"./FI.svg": "1edd",
	"./FJ.svg": "f497",
	"./FK.svg": "598a",
	"./FM.svg": "8566",
	"./FO.svg": "e66e",
	"./FR.svg": "a74e",
	"./GA.svg": "bdf7",
	"./GB.svg": "7d98",
	"./GD.svg": "c527",
	"./GE-AB.svg": "351b",
	"./GE-OS.svg": "4c2e",
	"./GE.svg": "9695",
	"./GF.svg": "23f4",
	"./GG.svg": "ac02",
	"./GH.svg": "29ff",
	"./GI.svg": "e9ea",
	"./GL.svg": "654c",
	"./GM.svg": "2bf4",
	"./GN.svg": "c64b",
	"./GP.svg": "ed90",
	"./GQ.svg": "e4aa",
	"./GR.svg": "54c0",
	"./GS.svg": "4dee",
	"./GT.svg": "fb30",
	"./GU.svg": "6994",
	"./GW.svg": "2ec0",
	"./GY.svg": "02fa",
	"./HK.svg": "2673",
	"./HM.svg": "e0fa",
	"./HN.svg": "adbb",
	"./HR.svg": "ccce",
	"./HT.svg": "189b",
	"./HU.svg": "6a94",
	"./IC.svg": "20be",
	"./ID.svg": "cfd7",
	"./IE.svg": "0ca3",
	"./IL.svg": "8b67",
	"./IM.svg": "0078",
	"./IN.svg": "b4b2",
	"./IO.svg": "3466",
	"./IQ.svg": "254b",
	"./IR.svg": "1ae7",
	"./IS.svg": "3515",
	"./IT.svg": "b3c6",
	"./JE.svg": "8dcb",
	"./JM.svg": "eb86",
	"./JO.svg": "bd21",
	"./JP.svg": "120d",
	"./KE.svg": "6814",
	"./KG.svg": "d08f",
	"./KH.svg": "cabc",
	"./KI.svg": "fbf0",
	"./KM.svg": "fb6d",
	"./KN.svg": "68e0",
	"./KP.svg": "cfa9",
	"./KR.svg": "dbaa",
	"./KW.svg": "e7cf",
	"./KY.svg": "d493",
	"./KZ.svg": "7eb6",
	"./LA.svg": "bff9",
	"./LB.svg": "039e",
	"./LC.svg": "5891",
	"./LI.svg": "7cc7",
	"./LK.svg": "6434",
	"./LR.svg": "e78b",
	"./LS.svg": "c5a8",
	"./LT.svg": "b1ce",
	"./LU.svg": "f311",
	"./LV.svg": "dc07",
	"./LY.svg": "aac3",
	"./MA.svg": "cd27",
	"./MC.svg": "592e",
	"./MD.svg": "fa01",
	"./ME.svg": "dda7",
	"./MF.svg": "a129",
	"./MG.svg": "f1d4",
	"./MH.svg": "9b99",
	"./MK.svg": "dc2d",
	"./ML.svg": "298d",
	"./MM.svg": "439a",
	"./MN.svg": "3915",
	"./MO.svg": "02f7",
	"./MP.svg": "7436",
	"./MQ.svg": "358c",
	"./MR.svg": "b4a4",
	"./MS.svg": "e673",
	"./MT.svg": "4613",
	"./MU.svg": "aa4f",
	"./MV.svg": "9646",
	"./MW.svg": "ec12",
	"./MX.svg": "165b",
	"./MY.svg": "477d",
	"./MZ.svg": "8320",
	"./NA.svg": "aa72",
	"./NC.svg": "d0df",
	"./NE.svg": "cec0",
	"./NF.svg": "ea9f",
	"./NG.svg": "b655",
	"./NI.svg": "a95e",
	"./NL.svg": "0089",
	"./NO.svg": "8103",
	"./NP.svg": "a1e1",
	"./NR.svg": "2797",
	"./NU.svg": "faa6",
	"./NZ.svg": "bd2c",
	"./OM.svg": "27bc",
	"./PA.svg": "985d",
	"./PE.svg": "f7a7",
	"./PF.svg": "2e98",
	"./PG.svg": "834f",
	"./PH.svg": "0001",
	"./PK.svg": "0054",
	"./PL.svg": "7988",
	"./PM.svg": "244f",
	"./PN.svg": "98e2",
	"./PR.svg": "b30c",
	"./PS.svg": "6734",
	"./PT.svg": "246d",
	"./PW.svg": "bf9e",
	"./PY.svg": "12a7",
	"./QA.svg": "a535",
	"./RE.svg": "c508",
	"./RO.svg": "a886",
	"./RS.svg": "fc01",
	"./RU.svg": "fbaa",
	"./RW.svg": "133f",
	"./SA.svg": "d8f2",
	"./SB.svg": "ec73",
	"./SC.svg": "74e2",
	"./SD.svg": "ca9e",
	"./SE.svg": "7157",
	"./SG.svg": "17da",
	"./SH.svg": "36c8",
	"./SI.svg": "eddc",
	"./SJ.svg": "23af",
	"./SK.svg": "a8c0",
	"./SL.svg": "21ac",
	"./SM.svg": "34f2",
	"./SN.svg": "4e8e",
	"./SO.svg": "30a9",
	"./SR.svg": "540e",
	"./SS.svg": "63df",
	"./ST.svg": "1023",
	"./SV.svg": "25c2",
	"./SX.svg": "57ed",
	"./SY.svg": "bf97",
	"./SZ.svg": "2f4c",
	"./TA.svg": "900b",
	"./TC.svg": "7a7e",
	"./TD.svg": "fa86",
	"./TF.svg": "97f5",
	"./TG.svg": "178d",
	"./TH.svg": "6997",
	"./TJ.svg": "9e84",
	"./TK.svg": "10d0",
	"./TL.svg": "2923",
	"./TM.svg": "2e87",
	"./TN.svg": "128d",
	"./TO.svg": "7284",
	"./TR.svg": "0e4a",
	"./TT.svg": "319b",
	"./TV.svg": "75cd",
	"./TW.svg": "7e35",
	"./TZ.svg": "8b10",
	"./UA.svg": "f79e",
	"./UG.svg": "6ae3",
	"./UM.svg": "ea96",
	"./US.svg": "f583",
	"./UY.svg": "deb3",
	"./UZ.svg": "1d8f",
	"./VA.svg": "e74d",
	"./VC.svg": "a9d5",
	"./VE.svg": "5a88",
	"./VG.svg": "ebee",
	"./VI.svg": "3786",
	"./VN.svg": "20ee",
	"./VU.svg": "3d79",
	"./WF.svg": "16c1",
	"./WS.svg": "e97c",
	"./XK.svg": "69cb",
	"./YE.svg": "8dad",
	"./YT.svg": "0d29",
	"./ZA.svg": "a0b5",
	"./ZM.svg": "3f74",
	"./ZW.svg": "ea84"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de0b";